import { Store } from "../../../flux/Store";
import { assertArray } from "../../utils/assert";
import { merge, replace, remove } from "../../../utils/merge";
import { names } from "./ListActions";

export interface ListStoreState<T>
{
    items: T[];
}

type Key = string | number;

// This store holds data for each table inside entity tab
export class ListStore<T> extends Store<ListStoreState<T>>
{
    constructor(readonly key: (item: T) => Key, readonly token: any)
    {
        super();
        this.state = { items: [] };

        // get rid of old items and set new items
        this.register<T[]>(names.SET_ITEMS, e => {
            if(e.meta === this.token) {
                const items: T[] = e.payload;
                if (e.meta == 6) {
                    (<any>window).sensors = items;
                }
                assertArray(items, 'array payload expected');
                return { items };
            }
        });

        // replace items by keys
        this.register<T[]>(names.REPLACE_ITEMS, e => {
            if(e.meta === this.token) {
                const newItems: T[] = assertArray(e.payload);
                const { items: oldItems } = this.getState();
                
                const items = replace(oldItems, newItems, this.key);
                if(oldItems !== newItems)
                    return { items };
            }
        });

        // replace items by keys and add new items
        this.register<T[]>(names.UPSERT_ITEMS, e => {
            if(e.meta === this.token) {
                const newItems: T[] = assertArray(e.payload);
                const { items: oldItems } = this.getState();
                
                const items = merge(oldItems, newItems, this.key);
                if(oldItems !== items)
                    return { items };
            }
        });

        // remove items by keys
        this.register<Key[]>(names.REMOVE_ITEMS, e => {
            if(e.meta === this.token) {
                const toDelete: Key[] = assertArray(e.payload);
                const { items: oldItems } = this.getState();
                
                const items = remove(oldItems, toDelete, this.key);
                if(oldItems != items)
                    return { items };
            }
        });
    }

    getItemsCount = () => this.state.items.length;
}


// WEBPACK FOOTER //
// ./src/app/flux/Grid/ListStore.ts